<div class="account-menu__list">
    <form [formGroup]="form" *ngIf="!user" class="account-menu__form pb-0" (ngSubmit)="login()">
        <div class="account-menu__form-title">{{"log_in"|translate}}</div>
        <div class="form-group">
            <label for="header-signin-email" class="sr-only">{{"emai_address"|translate}}</label>
            <input id="header-signin-email" type="email" class="form-control form-control-sm"
                [placeholder]="'email_address'|translate" formControlName="email" required>
            <div *ngIf="submitted && form.controls['email'].errors || form.controls['email'].invalid && (form.controls['email'].dirty || form.controls['email'].touched)"
                class="tetx-danger">
                <small *ngIf="form.controls['email'].errors.required">
                    {{"email_required"|translate}}.
                </small>
            </div>
        </div>
        <div class="form-group">
            <label for="header-signin-password" class="sr-only">{{"password"|translate}}</label>
            <div class="account-menu__form-forgot">
                <input id="header-signin-password" type="password" class="form-control form-control-sm"
                    [placeholder]="'password'|translate" formControlName="password">
                <a routerLink="/forgot-password" class="account-menu__form-forgot-link"
                    (click)="closeMenu.emit()">{{"forgot"|translate}}</a>
            </div>
            <div *ngIf="submitted && form.controls['password'].errors || form.controls['password'].invalid && (form.controls['password'].dirty || form.controls['password'].touched)"
                class="text-danger">
                <small *ngIf="form.controls['password'].errors.required">
                    {{"password_required"|translate}}.
                </small>
            </div>
        </div>
        <div class="form-group account-menu__form-button text-center">
            <button type="submit" class="btn btn-primary btn-sm">{{"login"|translate}}</button>
        </div>
        <div class="account-menu__form-link"><a routerLink="/register"
                (click)="closeMenu.emit()">{{"create_account"|translate}}</a></div>
        <div class="account-menu__form-link"><a routerLink="/track-order"
                (click)="closeMenu.emit()">{{"view_order"|translate}}</a></div>
        <div class="account-menu__divider"></div>

    </form>
    <div *ngIf="user">
        <a routerLink="/account/dashboard" class="account-menu__user" (click)="closeMenu.emit()">
            <!-- <div class="account-menu__user-avatar">
                <img src="assets/images/avatars/avatar-3.jpg" alt="">
            </div> -->
            <div class="account-menu__user-info">
                <div class="account-menu__user-name">{{user.name}}</div>
                <div class="account-menu__user-email">{{user.email}}</div>
            </div>
        </a>
        <div class="account-menu__divider"></div>
        <div class="account-menu__form-title pt-2 pb-0">{{"my_account"|translate}}</div>
        <ul class="account-menu__links pt-0">
            <li><a routerLink="/account/profile" (click)="closeMenu.emit()">{{"edit_profile"|translate}}</a></li>
            <!-- <li><a routerLink="/account/subscription" (click)="closeMenu.emit()">{{"subscription"|translate}}</a></li> -->
            <li><a routerLink="/account/orders" (click)="closeMenu.emit()">{{"order_history"|translate}}</a></li>
            <li><a routerLink="/account/bookings" (click)="closeMenu.emit()">{{"booking_history"|translate}}</a></li>
            <li><a routerLink="/compare" (click)="closeMenu.emit()">{{"compare"|translate}}</a></li>
            <!-- <li *ngIf="siteService.features?.quotations"><a routerLink="/account/quotation-drafts" (click)="closeMenu.emit()">{{"quotation_history"|translate}}</a></li> -->
            <li *ngIf="siteService.features?.quotations"><a routerLink="/account/quotation-drafts"
                    (click)="closeMenu.emit()">{{"b2c_quotations"|translate}}</a></li>
            <li *ngIf="siteService.features?.quotationRequests"><a routerLink="/rfq/center"
                    (click)="closeMenu.emit()">{{"rfq_center"|translate}}</a></li>

            <li><a routerLink="/account/messages" (click)="closeMenu.emit()">{{"messages"|translate}}</a></li>
            <li *ngIf="siteService.features?.chat"><a routerLink="/account/live-chat"
                    (click)="closeMenu.emit()">{{"live_chat"|translate}}</a></li>
            <li><a routerLink="/account/addresses" (click)="closeMenu.emit()">{{"addresses"|translate}}</a></li>
            <li><a routerLink="/account/password" (click)="closeMenu.emit()">{{"password"|translate}}</a></li>
        </ul>
        <div class="account-menu__divider"></div>
    </div>

    <div>
        <div class="account-menu__form-title pt-2 pb-0">{{"useful_links"|translate}}</div>
        <ul class="account-menu__links pt-0">
            <li *ngIf="!siteService.siteSetting?.companyId"><a routerLink="/apply-for-vendor"
                    (click)="closeMenu.emit()">{{"become_vendor"|translate}}</a></li>
            <li><a routerLink="/recruit" (click)="closeMenu.emit()">{{ translateService.currentLang === 'en' ? 'Careers' : 'وظائف' }}</a></li>
            <li *ngIf="siteService.features?.blogs"><a routerLink="/blog"
                    (click)="closeMenu.emit()">{{"blog"|translate}}</a></li>
            <li *ngIf="siteService.features?.multiStore"><a routerLink="/site/stores"
                    (click)="closeMenu.emit()">{{"stores"|translate}}</a></li>

            <li class="d-block d-lg-none" *ngIf="user?.isVendor; else becomeVendor">
                <a href="/admin" target="_blank" (click)="closeMenu.emit()">{{"admin_panel"|translate}}</a>
            </li>
            <ng-template #becomeVendor>
                <li class="d-block d-lg-none" *ngIf="!siteService.siteSetting?.companyId">
                    <a routerLink="/apply-for-vendor" (click)="closeMenu.emit()">{{"become_vendor"|translate}}</a>
                </li>
            </ng-template>
        </ul>
        <div class="account-menu__divider"></div>
        <div class="language-section">
            <span class="language-label">{{"language" | translate}}</span>
            <div class="language-switcher">
                <button 
                    class="language-btn" 
                    [class.active]="translateService.currentLang == 'en'"
                    (click)="changeLangage('en')"
                    type="button">
                    EN
                </button>
                <button 
                    class="language-btn" 
                    [class.active]="translateService.currentLang == 'ar'"
                    (click)="changeLangage('ar')"
                    type="button">
                    AR
                </button>
            </div>
        </div>
        <div class="account-menu__divider"></div>
        <div class="selector-section">
            <span class="selector-label">{{"country"|translate}}</span>
            <app-country-select variant="menu"></app-country-select>
        </div>
    </div>


    <div *ngIf="user">
        <div class="account-menu__divider"></div>
        <ul class="account-menu__links">
            <li><a routerLink="" (click)="logout()">{{"logout"|translate}}</a></li>
        </ul>
    </div>
</div>